<div class="emds">
  <div class="form-group" [ngClass]="{ 'required': isRequired() }">
    <label *ngIf="showLabel">{{ labelName }}</label>
    <div
      class="input-group"
      [ngClass]="{ 'required-invalid': isFormSubmitted() && error }"
    >
      <input
        #datePicker="bsDatepicker"
        bsDatepicker
        apBsDatePicker
        [defaultToStartOfDay]="defaultToStartOfDay"
        [defaultToEndOfDay]="defaultToEndOfDay"
        class="ap-datepicker-select form-control"
        id="{{ id }}-input"
        type="text"
        (keypress)="validateCharacter($event)"
        [formControl]="innerControl"
        [apCVAViewToModelChange]="this"
        [bsConfig]="bsConfig"
        [dateCustomClasses]="dateCustomClasses"
        [minDate]="minDate"
        [maxDate]="maxDate"
        [attr.disabled]="disabled"
        [ngClass]="{'required-field': required }"
        [ngStyle]="onApplyDatePickerStyle()"
      />
      <span class="input-group-btn input-group-append">
        <button
          type="button"
          class="ap-datepicker-date-btn btn btn-default btn-flush"
          id="{{ id }}-button"
          [disabled]="disabled"
          (click)="datePicker.toggle()"
        >
          <i class="glyphicon glyphicon-calendar ap-datepicker-date-icon"></i>
        </button>
      </span>
    </div>
    <div class="incorrect-input" *ngIf="isFormSubmitted() && error">
      {{ error }}
    </div>
  </div>
</div>
